import React, { useState } from 'react';

export default function HelpTooltip({ message, position = 'top' }) {
  const [show, setShow] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
  };

  return (
    <div className="relative inline-flex items-center">
      <button
        className="text-gray-400 hover:text-gray-600 text-sm rounded-full border border-gray-300 w-5 h-5 inline-flex items-center justify-center focus:outline-none"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={() => setShow(!show)}
        type="button"
        aria-label="Help"
      >
        ?
      </button>
      {show && (
        <div className={`absolute z-50 ${positionClasses[position]} px-4 py-2 text-sm text-white bg-gray-800 rounded-lg shadow-lg max-w-sm w-64`}>
          <p className="leading-relaxed">{message}</p>
          <div className="absolute w-2 h-2 bg-gray-800 transform rotate-45"
            style={{
              [position === 'top' ? 'bottom' : 'top']: '-4px',
              left: 'calc(50% - 4px)'
            }}
          />
        </div>
      )}
    </div>
  );
}
